import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { DialogService } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';
import { UtilityService } from 'src/app/core/utility.service';
import { RequestService } from 'src/app/core/request.service';
import { TranslateService } from '@ngx-translate/core';
import { RouteAuthorities, ValueLabel } from 'src/app/shared/base/base.models';
import { BaseListComponent } from 'src/app/shared/base/base-list.component';
import { Constants, SearchOperations } from 'src/app/app.constants';
import { CustomerOrderStatus } from '../customer-orders.models';
import { UserType, UserTypeOrders } from '../../users/users.models';

@Component({
  selector: 'app-customer-orders-list',
  templateUrl: './customer-orders-list.component.html',
  styleUrls: ['./customer-orders-list.component.scss']
})
export class CustomerOrdersListComponent extends BaseListComponent implements OnInit {
  public gridStateKey: string = 'customer_orders_list_state_grid_3';
  public lookupColumns: Array<string> = [ 'documentNumber', 'shippingFullName', 'distributionCalendar', 'locationTemplate', 'date', 'statusTemplate', 'userTypesTemplate', 'invoiceValue', 'totalValue', 'actionsTemplate'];
  public customerOrderStatuses: ValueLabel[] = [];
  public userTypes: ValueLabel[] = [];
  public CustomerOrderStatus = CustomerOrderStatus;
  public UserType = UserType;

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'CD_ORD', 'R_ORD', 'U_ORD', 'CD_ORD');
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
    
   }
  ngOnInit(): void {
    this.url = `${Constants.contextPath}/customer-orders`;
    this.prepareLookupData();
    this.getGridData();
  }

  public prepareLookupData() {
    this.userTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(UserTypeOrders, true), 'value', 'label', 'ENUMS.USER_TYPES.');
    this.customerOrderStatuses = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(CustomerOrderStatus, true), 'value', 'label', 'ENUMS.CUSTOMER_ORDERS_STATUS.');
  }
  
  public loadGridState = (): any => {
    return this.loadGridStateBase(this.gridStateKey, this.lookupColumns);
  }
  
  public saveGridState = (state: any): void => {
    this.saveGridStateBase(state, this.gridStateKey, this.lookupColumns);
  }

  protected getFilterValue(filter: any): string {
    let filterValue = '', filterArray = filter, filterOperators = {
      '=': '::',
      '<>': '!!',
      '>': '>>',
      '>=': '~:',
      '<': '<<',
      '<=': ':~',
      'contains': '~~',
      'notcontains': '~!',
      'startswith': '~<',
      'endswith': '~>'
    };
    if (filter.indexOf('and') == -1 && filter.indexOf('or') == -1)
      filterArray = [[filter[0], filter[1], filter[2]]];
    else if (filter.indexOf('or') != -1)
      filterArray = [[filter[0][0], '<>', filter.filterValue]];
    for (let filterItem of filterArray)
      if (Array.isArray(filterItem))
        if (filterItem.indexOf('and') == -1 && filterItem.indexOf('or') == -1) {
          let value = '';
          if (filterItem[0] == 'buyer.userType') {
            if (filterItem[2] == UserType[UserType.CLIENT_PUBLIC]) {
              filterItem[2] = "NULL";
            }
          }
          if (Object.prototype.toString.call(filterItem[2]) == '[object Date]')
            value = this.utilityService.formatDateToISO(filterItem[2]);
          else if (filterItem[0].toLowerCase().includes("code") && filterItem[2].length > 1)
            value = filterItem[2];
          else if ((Object.prototype.toString.call(filterItem[2]) == '[object String]' && filterItem[2].length > 2) || Object.prototype.toString.call(filterItem[2]) != '[object String]')
            value = filterItem[2];
          if (value != '')
            filterValue += `${filterItem[0].replace('.', SearchOperations.SPLIT_JOIN_OPERATOR)}${filterOperators[filterItem[1]]}${value}${SearchOperations.SPLIT_SINGLE_OPERATION}`;
        } else
          filterValue += `${this.getFilterValue(filterItem)}${SearchOperations.SPLIT_SINGLE_OPERATION}`;
    return filterValue.substr(0, filterValue.length - 2);
  }

}
